<template>
	<!-- редактирование войск во всех деревнях в выбранных списках целей -->
	<div ng-if="overlayController" class="windowOverlay" id="farmListEditTroops" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()" @click="gameModel.buildings.area.farmListEditTroopsShow = false"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="706">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="FarmList.EditTroops.Headline" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Редактировать войска</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div class="editUnits">
							<h6 class="headerTrapezoidal">
								<div class="content">
									<i class="village_village_small_flat_black"></i>
									<!-- ngIf: list -->
									<span ng-if="!list">3</span>
								</div>
							</h6>
							<span translate=""><span>Здесь ты можешь установить количество войск, которые следует отправить в каждую из выбранных деревень.</span></span>
							<div troops-details="" troop-data="troopDetails" unit-input-callback="checkInput">
								<table class="troopsTable gaul">
									<tbody class="troopsIconRow">
										<tr>
											<td ng-repeat="n in []|range:1:11" class="unit1">
												<i class="unitSmall gaul unitType1" unit-icon="" data="21" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" :content="tooltips[1]" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit2">
												<i class="unitSmall gaul unitType2 inactive" unit-icon="" data="22" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" :content="tooltips[2]" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit3">
												<i class="unitSmall gaul unitType3 inactive" unit-icon="" data="23" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit4">
												<i class="unitSmall gaul unitType4 inactive" unit-icon="" data="24" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" :content="tooltips[3]" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit5">
												<i class="unitSmall gaul unitType5 inactive" unit-icon="" data="25" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" :content="tooltips[4]" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit6">
												<i class="unitSmall gaul unitType6 inactive" unit-icon="" data="26" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" :content="tooltips[5]" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit7">
												<i class="unitSmall gaul unitType7 inactive" unit-icon="" data="27" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit8">
												<i class="unitSmall gaul unitType8 inactive" unit-icon="" data="28" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit9">
												<i class="unitSmall gaul unitType9 inactive" unit-icon="" data="29" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="unit10">
												<i class="unitSmall gaul unitType10 inactive" unit-icon="" data="30" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
											<td ng-repeat="n in []|range:1:11" class="hero">
												<i class="unitSmall hero_illu inactive" unit-icon="" data="hero" ng-init="group=troopData; unitId=n" clickable="" ng-class="{inactive: (troopData['originalTroops'] && !troopData['originalTroops'][n])
																				|| (!troopData['originalTroops'] && (!troopData['inputTroops'][n] || troopData['inputTroops'][n] <= 0)),
																	clickable: unitIconCallback}" tooltip="" tooltip-placement="above" tooltip-url="tpl/mainlayout/partials/troopTypeTooltip.html"></i>
												<!-- ngIf: troopData.unitBonuses[n+(troopData.tribeId-1)*10] -->
												<!-- ngIf: troopData['originalTroops'] || !troopData['inputTroops'] -->
											</td>
										</tr>
									</tbody>
									<tbody ng-if="troopData[troopsType+'Troops']" class="inputTroops" ng-repeat="troopsType in ['original', 'input', 'lost', 'trapped']">
										<!-- ngIf: troopsType == 'trapped' -->
										<tr>
											<td ng-repeat="n in [] | range:1:11" class="unit1">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput0" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit2">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput1" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit3">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput2" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit4">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput3" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit5">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput4" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit6">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput5" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit7">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput6" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit8">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput7" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit9">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput8" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="unit10">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput9" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
											<td ng-repeat="n in [] | range:1:11" class="hero">
												<!-- ngIf: troopsType == 'original' && (!troopData[troopsType+'Troops'][n] || troopData[troopsType+'Troops'][n] == 0) -->
												<!-- ngIf: troopsType == 'original' && troopData[troopsType+'Troops'][n] < 0 -->

												<!-- ngIf: troopsType != 'input' && troopData[troopsType+'Troops'][n] >= 1 -->
												<input ng-if="troopsType == 'input'" number="" ng-model="troopData.inputTroops[n]" hide-zero="true" hide-negative="true" ng-disabled="troopData.inputTroops[n] < 0" class="unitInput10" tooltip="" tooltip-translate="CombatSimulator.troopAmount" type="tel">
											</td>
										</tr>
									</tbody>
									<!-- ngIf: troopData.supply -->
									<!-- ngIf: troopData.cagedAnimals -->
								</table>
							</div>
							<!-- ngIf: editTroopsError -->
							<div class="buttonFooter">
								<button ng-class="{disabled: noUnitSelected || !unitInputChanged}" clickable="saveTroops()" class="clickable disabled">
									<div class="content">
										<span ng-transclude="" class="innerText">
											<span translate=""><span>Сохранить</span></span>
										</span>
										<!-- ngIf: price > 0 || forceGoldUsage -->
										<!-- ngIf: price == -1 && !forceGoldUsage -->
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
								<button clickable="closeOverlay();" @click="gameModel.buildings.area.farmListEditTroops = false" class="cancel clickable">
									<div class="content">
										<span ng-transclude="" class="innerText">
											<span translate=""><span>Отмена</span></span>
										</span>
										<!-- ngIf: price > 0 || forceGoldUsage -->
										<!-- ngIf: price == -1 && !forceGoldUsage -->
										<div class="animationOverlay"></div>
										<i class="checkmark action_check_small_flat_white"></i>
										<i class="checkmark action_check_small_flat_black"></i>
										<i class="checkmark action_check_small_flat_red"></i>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>